import React from "react";
import { Box, HStack, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const colors = ["#3182ce", "#dd6b20", "#38a169", "#e53e3e", "#718096"];

const RiskReviewStatusChart = ({ byStatus = {} }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const data = Object.entries(byStatus).map(([name, value]) => ({ name, value }));
  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);

  return (
    <Box bg={cardBg} borderWidth="1px" borderColor={borderColor} borderRadius="md" p={4} boxShadow="sm">
      <HStack justify="space-between" align="flex-start" mb={3}>
        <Box>
          <Text fontWeight="semibold">Status Distribution</Text>
          <Text fontSize="sm" color="gray.500">
            Current tenant requests
          </Text>
        </Box>
        <Box textAlign="right">
          <Text fontSize="2xl" lineHeight="1" fontWeight="bold">
            {total}
          </Text>
          <Text fontSize="xs" color="gray.500" textTransform="uppercase">
            Total
          </Text>
        </Box>
      </HStack>
      {data.length ? (
        <HStack align="center" spacing={5} flexWrap="wrap">
          <Box h="220px" flex="1 1 220px" minW="220px" position="relative">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data} dataKey="value" nameKey="name" innerRadius={62} outerRadius={88} paddingAngle={2}>
                  {data.map((entry, index) => (
                    <Cell key={entry.name} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            <Box position="absolute" inset="0" display="grid" placeItems="center" pointerEvents="none">
              <Box textAlign="center">
                <Text fontSize="2xl" fontWeight="bold" lineHeight="1">
                  {total}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  requests
                </Text>
              </Box>
            </Box>
          </Box>
          <VStack align="stretch" spacing={2} flex="1 1 180px">
            {data.map((entry, index) => (
              <HStack key={entry.name} justify="space-between">
                <HStack minW={0}>
                  <Box boxSize="9px" borderRadius="full" bg={colors[index % colors.length]} />
                  <Text fontSize="sm" noOfLines={1}>
                    {entry.name}
                  </Text>
                </HStack>
                <Text fontSize="sm" fontWeight="semibold">
                  {entry.value}
                </Text>
              </HStack>
            ))}
          </VStack>
        </HStack>
      ) : (
        <Text color="gray.500" fontSize="sm">No status data yet.</Text>
      )}
    </Box>
  );
};

export default RiskReviewStatusChart;
